<template>
  <section class="social_section available_section">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h5><span class="border_bottom">Also Available ON</span></h5>
        </div>
      </div>

      <!-- available companies-->
      <div class="available_companies">
        <div class="row">
          <div class="col-md-3 col-6">
            <div class="company_logo company_logo1">
              <a href="https://open.spotify.com/artist/3UGhltIiwrExCxs5CjJQFh?si=enFsVQOiSeOIhTQja9L7FQ&utm_source=copy-link&dl_branch=1" target="_blank">
                <img src="@/assets/images/Spotify_logo.svg" alt="Spotify_logo.svg">
              </a>
            </div>

          </div>
          <div class="col-md-3 col-6">
            <div class="company_logo company_logo2">
              <a href="https://music.youtube.com/channel/UCPXvcvwq0-Qfht1rJAFLTzQ" target="_blank">
                <img src="@/assets/images/youtube_available.svg" alt="youtube_available.svg">
              </a>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="company_logo company_logo3">
              <a href="https://music.apple.com/us/artist/gm-nanashi/1561494105" target="_blank">
                <img src="@/assets/images/apple-music-logo.svg" alt="apple-music-logo.svg">
              </a>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="company_logo company_logo4">
              <a href="https://gmnanashi.bandcamp.com/" target="_blank">
                <img src="@/assets/images/bandcamp-logotype-light-512.png" alt="bandcamp logo">
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'AlsoAvailableOn',
  data () {
    return {
    }
  },
  mounted () {}

}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AlsoAvailableOn.vue